// extracted by mini-css-extract-plugin
export var aiTwinWorkContent = "AiTwinWork-module--aiTwinWorkContent--cvElf";
export var aiTwinWorkWrapper = "AiTwinWork-module--aiTwinWorkWrapper--yH5AE";
export var description = "AiTwinWork-module--description--6c7pm";
export var headerSection = "AiTwinWork-module--headerSection--Ry53J";
export var mainTitle = "AiTwinWork-module--mainTitle--01jwm";
export var overlayContent = "AiTwinWork-module--overlayContent--L-Dd7";
export var overlayTitle = "AiTwinWork-module--overlayTitle--fuhIF";
export var playButton = "AiTwinWork-module--playButton--+ILN9";
export var playButtonText = "AiTwinWork-module--playButtonText--cz3CN";
export var playIcon = "AiTwinWork-module--playIcon--GqYCU";
export var videoImage = "AiTwinWork-module--videoImage--jzYdQ";
export var videoImageContainer = "AiTwinWork-module--videoImageContainer---ljGq";
export var videoOverlay = "AiTwinWork-module--videoOverlay--zxupO";
export var videoSection = "AiTwinWork-module--videoSection--LteyD";
export var videoWrapper = "AiTwinWork-module--videoWrapper--xTbxI";